import React from "react";

export default ({ onClick, active, index, carouselState, carouselState: { currentSlide }}) => (
        <li>
            <button
                className={ "m-dot-list__item" + ( active ? " m-dot-list__item--active" : "" ) }
                aria-label={"Move carousel to " + index }
                onClick={ () => onClick() }
            />
        </li>
    )